import * as React from "react";
import { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import { History } from "history";
import { applySortOrderToYearGroupingIsAfterValues, SchoolWorkloadConfig, sortYearGroupingsByIsAfterValues, YearGrouping } from "../../../models/SchoolWorkloadConfig";
import HelpBox from "./HelpBox";
import YearGroupingEditor from "../../YearGroupingsEditor";
import * as _ from 'lodash';
import { MessageBarType, PrimaryButton } from "office-ui-fabric-react";
import Actions from "../../../redux/Actions";
import SchoolPageTitle from "../../SchoolPageTitle";
import AdminSchoolMenu from "../../AdminSchoolMenu";


interface YearGroupingsPageProps {
    tenantId: string;
    schoolCode: string;
    
    apiService: ApiService;
    history: History;
}

interface YearGroupingsPageState {
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    newYearGroupings: YearGrouping[];
    aggregatePermissions: boolean;
}

class YearGroupingsPage extends Component<YearGroupingsPageProps & DispatchProps, YearGroupingsPageState> {

    constructor(props: YearGroupingsPageProps & DispatchProps) {
        super(props);
        this.state = {
            newYearGroupings: [],
            aggregatePermissions: false
        };

    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId) {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);

            this.setState({
                schoolWorkloadConfig
            });

            if (schoolWorkloadConfig.yearGroupings.aggregatePermissions) {
                this.setState({aggregatePermissions: true});
            }
        }
    }

    async componentDidUpdate(prevProps: Readonly<YearGroupingsPageProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.props.tenantId != prevProps.tenantId || this.props.schoolCode != prevProps.schoolCode) {
            const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
            this.setState({
                schoolWorkloadConfig
            });
        }

        if (this.state.schoolWorkloadConfig !== prevState.schoolWorkloadConfig) {

            const yearGroupingItems = _.cloneDeep(this.state.schoolWorkloadConfig?.yearGroupings?.items || []);
            this.setState({
                newYearGroupings: sortYearGroupingsByIsAfterValues(yearGroupingItems)
            });
        }
    }

    private save = async (): Promise<boolean> => {
        if (this.state.schoolWorkloadConfig === undefined) {
            console.log("Cannot find school workload config");
            return false;
        }

        const updatedConfig = _.cloneDeep(this.state.schoolWorkloadConfig);

        applySortOrderToYearGroupingIsAfterValues(this.state.newYearGroupings);

        updatedConfig.yearGroupings.items = this.state.newYearGroupings;

        if (this.state.aggregatePermissions)
        {
            updatedConfig.yearGroupings.aggregatePermissions = true;
        }

        const savedSchoolWorkloadConfig = await this.props.apiService.putSchoolConfigJson(this.props.tenantId, this.props.schoolCode, updatedConfig);

        this.setState({
            schoolWorkloadConfig: savedSchoolWorkloadConfig
        });

        await this.props.dispatch(Actions.showMessageBar("Saved year groupings to config", MessageBarType.success));

        return true;
    }


    public render(): JSX.Element {
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Year Groups" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <HelpBox Icon={"PageHeaderEdit"} TitleText={"Edit Year Groups"} HelpBoxText={"This page allows you to change the current year groupings for the school. After the year groupings have been saved please run SetupAllADGroups and SetupSubjectSites to apply any changes to the subject sites."}></HelpBox>

                <div className="flex-item--flex-1 flex-column flex--align-items-center">

                    <h3>Current Year Groupings</h3>

                    {this.state.newYearGroupings ? <YearGroupingEditor yearGroupings={this.state.newYearGroupings} onYearGroupingChange={(yearGroups: YearGrouping[]) => { this.setState({ newYearGroupings: yearGroups }) }} aggregatePermissions={this.state.aggregatePermissions} onAggregatePermissionsChanged={(choice: boolean) => { this.setState({ aggregatePermissions: choice }) }} schoolWorkloadConfig={this.state.schoolWorkloadConfig} /> : null}

                    <PrimaryButton style={{ margin: "auto" }} onClick={this.save} text={`Save Changes`} />

                </div> 
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): YearGroupingsPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };

    }
)(YearGroupingsPage)